import React from 'react';
import style from './MetricHighlight.module.css';

const MetricHighlight = ({ name, big, children }) => {
  return (
    <div>
      <span className={style.name}>{name}</span>
      <span className={`${style.metric} ${big && style.metricBig}`}>{children}</span>
    </div >
  );
};

export default MetricHighlight;
